export default "__VITE_ASSET__lGIklTDb__"